import { useEffect, useState } from 'react';
import { Link } from 'react-router';

// hooks
import useQueryParam from '@hooks/use-query-param';
import { useNotifications } from '@store/notifications';

// UI
import BackButton from '@components/back-button';
import Button from '@components/button';

// images
import LogoImg from '@assets/logo.png';

// styles
import css from './styles.module.css';

const URL = '/api/auth/verify-token';

const SUCESS_TEXT =
  "Your email has been successfully confirmed! You're all set to start exploring TurboPush";

function EmailConfirmed() {
  const [subTitle, setSubtitle] = useState(SUCESS_TEXT);

  const { addNotification } = useNotifications();
  const token = useQueryParam('token');

  useEffect(() => {
    if (!token) {
      return;
    }

    async function checkVerificationToken() {
      const response = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
        }),
      });

      const data = await response.json();

      if (data.status === 'error') {
        setSubtitle(data.msg);
      }

      addNotification(data.msg, data.status);
    }

    checkVerificationToken();
  }, [token]);

  return (
    <main className={css.resetPasswordRoot}>
      <div className={css.content}>
        <BackButton className={css.backButton} iconClassname={css.backIcon} />

        <img src={LogoImg} alt="logo" className={css.logo} />
        <h1 className={css.title}>Email confirmed</h1>

        <p className={css.subtitle}>{subTitle}</p>

        <Link to="/account">
          <Button type="submit" size="large" className={css.submitButton}>
            Get started
          </Button>
        </Link>
      </div>
    </main>
  );
}

export default EmailConfirmed;
